module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-130.e2c7958a.svg";